import { render, staticRenderFns } from "./DatePeriodSelector.vue?vue&type=template&id=f156b424&scoped=true&"
import script from "./DatePeriodSelector.vue?vue&type=script&lang=js&"
export * from "./DatePeriodSelector.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f156b424",
  null
  
)

export default component.exports